import * as React from 'react';

import { Background } from '@/components/background/background';
import Row from '@/components/row';
import Typography from '@/components/typography';

import { LightColor } from '@/enums/light-color';

export type SparkLineOverflowProps = {
  backgroundColor?: LightColor;
  caption?: string;
  headline?: string;
};

const SparkLineOverflow = ({
  backgroundColor,
  caption,
  headline,
}: SparkLineOverflowProps) => {
  return (
    <div className='relative mb-6'>
      <div className='absolute bottom-0 left-0 right-0 top-16 z-0 lg:top-5'>
        <Background backgroundColor={backgroundColor} />
      </div>
      <Row className='pb-3'>
        <div className='relative z-10 flex flex-col-reverse lg:flex-row'>
          <div className='lg:w-[40%] lg:pt-20'>
            {caption && (
              <Typography.Heading6 className='mb-2'>
                {caption}
              </Typography.Heading6>
            )}
            {headline && <Typography.Heading1>{headline}</Typography.Heading1>}
          </div>
          <div className='flex max-h-[235px] max-w-[450px] flex-1 justify-end align-top lg:justify-start'>
            <SparkLineImage />
          </div>
        </div>
      </Row>
    </div>
  );
};
export default SparkLineOverflow;

const SparkLineImage = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='456'
    height='241'
    viewBox='0 0 456 241'
    fill='none'
  >
    <path
      d='M453 3C327.279 57.0049 306.405 236.834 306.272 237.994C306.27 238.006 306.272 238.004 306.269 237.993C305.937 236.874 268.29 111 149 111C29.1771 111 3 238 3 238'
      className='stroke-primary'
      strokeWidth='5.00587'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
